<template>
    <div>
        <el-card>
            <el-table :data="detail.toRelease">

                <el-table-column label="创建人" prop="user"></el-table-column>

                <el-table-column label="创建时间" prop="updateTime"></el-table-column>

                <el-table-column label="版本" prop="version"></el-table-column>
                
            </el-table>
        </el-card>
    </div>
</template>

<script>
export default {
    props: {
        detail: Object
    }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    
</style>